module.exports = __webpack_public_path__ + "media/packs/images/flags/AD-8d8112274911e4b02917a0a220a60213.png";